import { useTreeContext } from "../../../context/TreeDataContext";
import { useTemplateContext } from "../../../context/TemplateContext";
import { useStatemachineContext } from "../../../context/StatemachineContext";
import React, { useEffect, useState } from "react";
import { toastError } from "../../../utils/toastUtils";
import { apiConfig } from "../../../utils/Config/DefaultConfig/apiConfig";
import Input from "../../../components/FormComponents/Input";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import MultiRadio from "../../../components/FormComponents/MultiRadio";
import Button from "../../../components/FormComponents/Button";

const CreateWebhook = ({ createWebhook }) => {
  const { stateMachineExplorerData, sqlTemplateExplorerData } = useTreeContext();
  const { fetchSqlTemplates } = useTemplateContext();
  const { fetchAllStateMachine } = useStatemachineContext();

  const [createConfig, setCreateConfig] = useState({
    name: "",
    table_type: "statemachine",
    rdbms_id: "",
    sm_id: "",
    version: "v2"
  });
  const [dataOfSMsAndRDBMs, setDataOfSMsAndRDBMs] = useState({
    entity: [],
    statemachine: [],
    rdbms: []
  });

  const getAndSetDataOfDbs = async () => {
    if (!stateMachineExplorerData) {
      await fetchAllStateMachine();
    }
    if (!sqlTemplateExplorerData) {
      await fetchSqlTemplates();
    }
    if (stateMachineExplorerData && sqlTemplateExplorerData) {
      const entityList = [];
      const smList = [];
      for (let sm of stateMachineExplorerData) {
        if (sm.type === "default") {
          smList.push(sm);
        }
        if (sm.type === "entity") {
          entityList.push(sm);
        }
      }
      const rdbmsList = sqlTemplateExplorerData.find((temp) => temp.id === "rdbms").items;
      setDataOfSMsAndRDBMs({
        rdbms: rdbmsList,
        entity: entityList,
        statemachine: smList
      });
    }
  };

  useEffect(() => {
    getAndSetDataOfDbs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateMachineExplorerData, sqlTemplateExplorerData]);

  const selectedType = createConfig.table_type;
  const dropdownLabelName =
    selectedType === "rdbms" ? "RDBMS" : selectedType === "statemachine" ? "State Machine" : "Entity";
  const selectedTypeValue = createConfig.table_type === "rdbms" ? "rdbms_id" : "sm_id";

  const handleChangeSelect = (value) => {
    setCreateConfig({ ...createConfig, [selectedTypeValue]: value });
  };

  const handleChangeRadio = (e) => {
    const { name } = e.target;
    setCreateConfig({ ...createConfig, table_type: name, sm_id: "", rdbms_id: "" });
  };

  const onSave = () => {
    if (createConfig.name.trim().length === 0) {
      toastError("Please enter a name");
      return;
    }
    if (createConfig.rdbms_id.length === 0 && createConfig.sm_id.length === 0) {
      toastError(`Please Select ${selectedType} `);
      return;
    }
    let webhookConfig;
    if (createConfig.version === "v1") {
      webhookConfig = {
        ...apiConfig.webhook,
        name: createConfig.name,
        table_type: createConfig.table_type,
        rdbms_id: createConfig.rdbms_id,
        sm_id: createConfig.sm_id,
        version: createConfig.version
      };
    } else {
      webhookConfig = {
        ...apiConfig.webhook_config,
        name: createConfig.name,
        table_type: createConfig.table_type,
        rdbms_id: createConfig.rdbms_id,
        sm_id: createConfig.sm_id,
        version: createConfig.version
      };
    }
    createWebhook(webhookConfig);
  };

  const handleVersionChange = (e) => {
    setCreateConfig({ ...createConfig, version: e.target.value });
  };

  return (
    <div className="builder_form">
      <div className="builder_form">
        <Input
          type="text"
          label="Enter Webhook Name"
          value={createConfig.name}
          onChange={(e) => setCreateConfig({ ...createConfig, name: e.target.value })}
        />
      </div>
      <div className="builder_form ">
        <label className="builder_label">Select Type</label>
        <div className="blocks_type_radio">
          <label className="builder_label d_flex align_center">
            <Input type="radio" checked={selectedType === "entity"} name="entity" onChange={handleChangeRadio} />
            Entity
          </label>
          <label className="builder_label d_flex align_center">
            <Input
              type="radio"
              checked={selectedType === "statemachine"}
              name="statemachine"
              onChange={handleChangeRadio}
            />
            Workflow
          </label>
          <label className="builder_label d_flex align_center">
            <Input type="radio" checked={selectedType === "rdbms"} name="rdbms" onChange={handleChangeRadio} />
            RDBMS
          </label>
        </div>
      </div>
      <div className="builder_form">
        <SingleSelectBox
          selectedData={createConfig[selectedTypeValue]}
          options={dataOfSMsAndRDBMs[selectedType]}
          onChange={(obj) => handleChangeSelect(obj.id)}
          placeholder={`Select ${dropdownLabelName}`}
          label={`Select ${dropdownLabelName}`}
        />
      </div>
      <div className="builder_form">
        <MultiRadio
          keyName="version"
          label="Select Version"
          options={[
            { id: "v1", name: "Version 1" },
            { id: "v2", name: "Version 2" }
          ]}
          selectedValue={createConfig.version}
          onChange={handleVersionChange}
        />
      </div>

      <Button onClick={onSave}>Save</Button>
    </div>
  );
};

export default CreateWebhook;
